import 'bootstrap/dist/css/bootstrap.min.css';
import '../src/assets/css/style.css';
import '../src/assets/css/responsive.css';
import { Routes, Route } from "react-router-dom";
import Header from './component/Header';

import Home from './pages/Home';
import Footer from './component/Footer';
import ScrollToTop from './component/ScrollToTop';
import Player from './pages/Player';
import Categorypage from './pages/Categorypage';
import MusicPlayer from './pages/MusicPlayer';
import NotFoundPage from './pages/NotFoundPage';
//import Agriculturepage from './pages/agriculture/Agriculturepage';



function App() {
  return (
    <>
    <ScrollToTop />
    <Header/>
    <Routes>
          <Route index element={<Home/>} />
          <Route path="home" element={<Home/>} />
          <Route path="category/:categoryname" element={<Categorypage/>} />
         
          {/* <Route path="player" element={<Player/>} /> */}
          {/* <Route path="player" element={<MusicPlayer/>} /> */}
          <Route path="*" element={<NotFoundPage />} status={404}/>
          
          </Routes>
      <Footer/>
     
     
    </>
  );
}

export default App;
